import styled from 'styled-components';
import { GhostButton, BUTTON_SIZES } from 'ui/button';
import { colors, fontSizes, spacing } from 'ui/theme';

import { RECENT_EVENTS_ROW_COUNT } from '../constants';
import { PlaceholderListItem } from './PlaceholderListItem';

const displayText = {
  loadingMessage: 'Could not load recent events',
  reload: 'Try again',
};

const ReloadButton = styled(GhostButton).attrs({ size: BUTTON_SIZES.SMALL })`
  && {
    color: ${colors.textLink};
    text-decoration: underline;
    padding: 0 ${spacing.eighth};
    margin: 0 ${spacing.base} 0 -${spacing.single};
    height: auto;
    font-size: ${fontSizes.s14};

    &::before {
      left: 0;
      right: 0;
      border-radius: ${spacing.eighth};
    }

    &:focus {
      color: ${colors.linkFocus};
      :before {
        border-color: ${colors.linkFocusOutline};
      }
    }
    &:active {
      color: ${colors.linkActive};
    }
    &:hover {
      color: ${colors.linkHover};
      background-color: transparent;
    }
  }
`;

type ErrorPlaceholderProps = {
  onReloadButtonClick: () => void;
};

export const ErrorPlaceholder = ({ onReloadButtonClick }: ErrorPlaceholderProps) => (
  <PlaceholderListItem $rowSpan={RECENT_EVENTS_ROW_COUNT} data-test="error-placeholder">
    <div>{displayText.loadingMessage}</div>
    <ReloadButton onClick={onReloadButtonClick}>{displayText.reload}</ReloadButton>
  </PlaceholderListItem>
);
